import { render, staticRenderFns } from "./u-swiper-pagination-filled.vue?vue&type=template&id=b8696f5a&scoped=true&"
import script from "./u-swiper-pagination-filled.vue?vue&type=script&lang=js&"
export * from "./u-swiper-pagination-filled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8696f5a",
  null
  
)

export default component.exports